module.exports = __webpack_public_path__ + "static/media/purchase-chest-epic.dd4cbb33.png";